// Shared notification event metadata used by the Following page + Account settings.
export const ALL_EVENT_TYPES = ["new_message", "new_board_post", "new_event", "new_review", "event_updated", "team_updated", "trainer_updated", "listing_updated"];

export const EVENT_LABELS = {
    new_message: "New message",
    new_board_post: "New message board post",
    new_team: "New team",
    new_event: "New event",
    new_review: "New review",
    new_trainer: "New trainer",
    new_comment: "New comment on a post",
    event_updated: "Event details updated",
    team_updated: "Team details updated",
    trainer_updated: "Trainer details updated",
    listing_updated: "Trainer listing updated",
};

export const EVENT_HELP = {
    new_message: "When they post a message on their board",
    new_board_post: "When someone posts on their message board",
    new_team: "When they add a new team",
    new_event: "When they post a new event",
    new_review: "When someone posts a review",
    new_trainer: "When they add a trainer profile",
    new_comment: "When they comment on another person's post",
    event_updated: "When an event you follow changes its details",
    team_updated: "When a team you follow changes its details",
    trainer_updated: "When a trainer you follow changes their details",
    listing_updated: "When a trainer listing you follow changes its details",
};

// Which event types are meaningful for each follow target type.
export const EVENTS_FOR_TARGET = {
    user: ["new_message", "new_event"],
    trainer: ["new_message", "new_event", "trainer_updated"],
    team: ["new_board_post", "new_event", "new_review", "team_updated"],
    event: ["new_board_post", "new_review", "event_updated"],
    trainer_listing: ["new_board_post", "new_review", "listing_updated"],
};

export const DEFAULT_CHANNELS = { in_app: true, email: false };
export const DEFAULT_DEFAULTS = ALL_EVENT_TYPES.reduce((acc, t) => ({ ...acc, [t]: true }), {});
